export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const GET_USER_DATA = "GET_USER_DATA";
export const LOADING = "LOADING";
